<template>
  <div id="cat" v-cloak>
    <div class="vx-row my-4">
      <div class="vx-col w-full">
        <vs-button
          @click.prevent="createSalePlans()"
          class="bg_l_green"
          v-has-permission="permission30"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          ثبت پلن جدید
        </vs-button>
      </div>
    </div>
    <modify-popup
      :show="showModifyPlan"
      @finish="onfinish"
      @close="closeModifyPopup"
      :modelModify="modelModify"
    ></modify-popup>
    <new-create-plan
      :show="showNewCreatePlan"
      @close="closeCreatePlanPopup"
      @finish="onfinish"
    ></new-create-plan>
    <product-list
      :show="showProductList"
      @close="closeProductsListPopup"
      :currentPlan="currentPlan"
      :showProductList="showProductList"
    ></product-list>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('Name'), sort: 'Name' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 35%">
              {{ row.name }}
            </td>
            <td style="width: 35%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
            <td style="width: 25%; text-align: right !important">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-edit"
                class="bordered-btn"
                @click.prevent="onShowProductList(row)"
                v-has-permission="permission29"
                >جزییات</vs-button
              >
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="editPromoterPlanName(row)"
                class="ml-4 d-inline"
                v-has-permission="permission31"
              ></vs-button>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteSalePlans(row)"
                class="d-inline"
                v-has-permission="permission32"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import NewCreatePlan from "./NewCreatePlan.vue";
import ProductList from "./ProductList.vue";
import modifyPopup from "./ModifyPopup.vue";

export default {
  name: "saleManagement_BasicDefinitions_SalesPartnerPlan_GridPlan",
  components: {
    NewCreatePlan,
    DataGrid,
    ProductList,
    modifyPopup,
    modelModify: {},
  },
  data() {
    return {
      permission29: "GetAllBeneficiaryRuleWithPaging",
      permission30: "CreatePromoterPlan",
      permission31: "ModifyName",
      permission32: "RemovePromoterPlan",
      currentPlan: {},
      gridDataSource: {
        type: "app",
        service: "Promotion/api/PromoterPlan",
      },
      gridSearchData: {},
      showNewCreatePlan: false,
      showProductList: false,
      showModifyPlan: false,
    };
  },
  methods: {
    ...mapActions({
      removePlan: "SalesPartnerPlan/remove",
    }),
    onShowProductList(row) {
      this.currentPlan = row;
      this.showProductList = true;
    },
    createSalePlans() {
      this.showNewCreatePlan = true;
    },
    editPromoterPlanName(model) {
      this.modelModify = {
        id: model.id,
        name: model.name,
      };
      this.showModifyPlan = true;
    },
    closeProductsListPopup() {
      this.showProductList = false;
    },
    closeCreatePlanPopup() {
      this.showNewCreatePlan = false;
    },
    closeModifyPopup() {
      this.showModifyPlan = false;
    },
    onfinish() {
      this.closeCreatePlanPopup();
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    deleteSalePlans(row) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removePlan(row.id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
  },
};
</script>
